const tabsFunction = () => {
  const tabsSections = document.querySelectorAll(".tabs-container");

  const showTabContent = (tab, parent) => {
    const indexTab = tab.dataset.tab;
    const tabContents = parent.querySelectorAll(".tab-content");
    
    if (tabContents.length > 0) {
      const indexTabContent = parent.querySelector(`.tab-content[data-tab="${indexTab}"]`);

      tabContents.forEach(content => {
        content.classList.remove("show");
      });
  
      indexTabContent.classList.add("show");
    } else {
      const tabContents2 = parent.querySelectorAll(".tab-carousel");
      const indexTabContent = parent.querySelector(`.tab-carousel[data-tab="${indexTab}"]`);

      tabContents2.forEach(content => {
        content.classList.remove("show");
      });
  
      indexTabContent.classList.add("show");

    }
  }
  
  const tabsClickFunction = (parent) => {
    const titles = parent.querySelectorAll(".tab-title");
  
    titles.forEach(tabTitle => {
      console.log(tabTitle)
      tabTitle.addEventListener("click", () => {
        titles.forEach(element => {
          element.dataset.active = "false";
        });
  
        tabTitle.dataset.active = "true";
        showTabContent(tabTitle, parent);
      });
    });
  }
  
  if (tabsSections.length > 0) {
    tabsSections.forEach(tabContainer => {
      tabsClickFunction(tabContainer);
    });
  }
}


setTimeout(() => {
  tabsFunction();
}, 300);